import { useEffect, useState } from 'react';
import PieChart from '../ui/PieChart';
import { ChartData } from 'chart.js';
import { IndustryColorsForPiechart } from '../../constants/charts.constant';
import { StocksOnHandBySector } from '../../models/dashboard';
import { FormatMoneyToDisplay } from '../../helper/currency-helper';

const StocksOnHandByIndustryCard = ({ chartData }: PropsType) => {
  const [data, setData] = useState<ChartData | null>(null);
  const [totalInvestedAmount, setTotalInvestedAmount] = useState<number>(0);
  useEffect(() => {
    if (!chartData) return;

    const totalStocks = chartData.reduce(
      (prev, curr) => prev + curr.stocksOnHand,
      0
    );
    const totalAmount = chartData.reduce((prev, curr) => prev + curr.profit, 0);

    setTotalInvestedAmount(totalAmount);
    setData({
      labels: chartData.map((data) => data.sector),
      datasets: [
        {
          label: 'Invested Amount',
          data: chartData.map((data) =>
            Math.round((data.stocksOnHand / totalStocks) * 100)
          ),
          backgroundColor: chartData.map(
            (data) => IndustryColorsForPiechart[data.sector].bg
          ),
          hoverBackgroundColor: chartData.map(
            (data) => IndustryColorsForPiechart[data.sector].hover
          ),
        },
      ],
    });
  }, [chartData]);
  return (
    <div className="flex flex-col col-span-full sm:col-span-6 xl:col-span-4 bg-white shadow-lg rounded-sm border border-slate-200">
      <header className="px-5 py-4 border-b border-slate-100 flex items-center">
        <h2 className="font-semibold text-slate-800">
          Stock Holdings by Industry
        </h2>
      </header>
      <div className="px-5 py-3">
        <div className="text-sm italic mb-2">
          Here is the value of your portfolio by industry:
        </div>
        <div className="text-3xl font-bold text-slate-800">
          {FormatMoneyToDisplay(totalInvestedAmount)}
        </div>
      </div>
      {/* Chart built with Chart.js 3 */}
      {/* Change the height attribute to adjust the chart height */}
      {data && <PieChart data={data} width={389} height={220} />}
    </div>
  );
};

type PropsType = {
  chartData: StocksOnHandBySector[];
};

export default StocksOnHandByIndustryCard;
